import axios from "axios";

const token = JSON.parse(localStorage.getItem("user"))?.access_token;
export const dashboardApi = axios.create({
  "content-type": "application/json",
  "Access-Control-Allow-Origin": "*",
  headers: token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : "",
});

export const dashboardURL = "http://197.243.24.153:20105/api/v1";
export const baseUrl = process.env.REACT_APP_API_URL;
